import Pqp from "./Pqp";

export default class Parser {
  static parse(s) {
    var sFinal = "";
    // a { b | c { d | e } | {f | {g | h }}
    // b | c { d | e } | {f | {g | h }}
    // d | e } | {f | {g | h }}
    // Conta le occorrenze di aperte e chiuse per vedere se ci sono errori
    var nAperte = Parser.conta(s, "{");
    var nChiuse = Parser.conta(s, "}");
    if (nAperte > nChiuse) {
      Trace.trace("--->" + s);
      return "Parse Error! Ci sono piu' parentesi { che }";
    }
    if (nAperte < nChiuse) {
      Trace.trace("--->" + s);
      return "Parse Error! Ci sono piu' parentesi } che {";
    }

    var pi = -1;
    var pf = -1;
    // Identifica lo slice piu' interno
    for (var x = 0; x < s.length; x++) {
      var c = s.charAt(x);
      if (c == "{") {
        pi = x;
      }
      if (c == "}") {
        // Se trova prima di tutto una } c'e' un errore
        if (pi == -1) {
          Trace.trace("--->" + s);
          return "Parse Error! Trovata } prima di {";
        }
        pf = x;
        break;
      }
    }
    if (pi == -1) {
      // non ci sono piu' parentesi!
      sFinal = s.trim();
      sFinal = Pqp.safeReplace(sFinal, "  ", " ");
      sFinal = Pqp.safeReplace(sFinal, "  ", " ");
      return sFinal;
    }
    // identifica lo slice
    /*trace("s: " + s);
			trace("pi: " + pi);
			trace("pf: " + pf);*/
    var sSlice = s.substring(pi, pf + 1);
    //trace("Slice: "+sSlice);
    var sScelta = Parser.scegli(sSlice);
    //trace("Scelta: " + sScelta);
    //sFinal = Pqp.safeReplace(s, sSlice, sScelta);
    sFinal = s.replace(sSlice, sScelta);

    //trace("Final: "+sFinal);
    return Parser.parse(sFinal);
  }

  static scegli(s) {
    var sTmp = Pqp.safeReplace(s, "{", "");
    sTmp = Pqp.safeReplace(sTmp, "}", "");
    sTmp = sTmp.trim();
    var sRet = "";
    if (sTmp.indexOf("|") > -1) {
      // Effettua una scelta tra le opzioni
      // Controlla ancora se ci sono dei tag particolari
      if (sTmp.indexOf("#+") > -1) {
        return Parser.parseWithDifferentProb(sTmp);
      } else {
        var aTmp = sTmp.split("|");
        sRet = aTmp[Pqp.rnd(aTmp.length - 1)].trim();
      }
    } else {
      // Decide se metterlo o no
      if (sTmp.indexOf("#-") > -1) {
        return Parser.parseLessProb(sTmp);
      } else {
        if (Pqp.check(0.5)) {
          sRet = sTmp;
        } else {
          sRet = "";
        }
      }
    }
    return sRet;
  }

  static parseLessProb(sTmp) {
    var aFin = new Array();
    var n = sTmp.indexOf("#-");
    var sCmp = sTmp.substr(n + 2);
    var sn = "";
    for (var y = 0; y < sCmp.length; y++) {
      if (sCmp.charAt(y) == "#") {
        break;
      } else {
        sn += sCmp.charAt(y);
      }
    }
    var nVolte = parseInt(sn);
    var sToAdd = Pqp.safeReplace(sTmp, "#-" + sn + "#", "");
    aFin.push(sToAdd);
    for (var z = 0; z < nVolte; z++) {
      aFin.push("");
    }
    aFin = Pqp.shuffle(aFin);
    var sRet = aFin[Pqp.rnd(aFin.length - 1)].trim();
    return sRet;
  }

  static parseWithDifferentProb(s) {
    var aTmp = s.split("|");
    var aFin = new Array();
    for (var x = 0; x < aTmp.length; x++) {
      var sTmp = aTmp[x];
      var n = sTmp.indexOf("#+");
      if (n >= 0) {
        var sCmp = sTmp.substr(n + 2);
        var sn = "";
        for (var y = 0; y < sCmp.length; y++) {
          if (sCmp.charAt(y) == "#") {
            break;
          } else {
            sn += sCmp.charAt(y);
          }
        }
        var nVolte = parseInt(sn);
        var sToAdd = Pqp.safeReplace(sTmp, "#+" + sn + "#", "");
        sToAdd = sToAdd.trim();
        for (var z = 0; z < nVolte; z++) {
          aFin.push(sToAdd);
        }
      } else {
        aFin.push(sTmp);
      }
    }
    aFin = Pqp.shuffle(aFin);
    var sRet = aFin[Pqp.rnd(aFin.length - 1)].trim();
    return sRet;
  }

  static conta(s, c) {
    var nOcc = 0;
    for (var x = 0; x < s.length; x++) {
      var cTmp = s.charAt(x);
      if (cTmp == c) {
        nOcc++;
      }
    }
    return nOcc;
  }
}
